/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 3718:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(5671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(2963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(1120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js
var wrapNativeSuper = __webpack_require__(7112);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7757);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/scripts/utils/body-lock.js
var body_lock = __webpack_require__(1709);
;// CONCATENATED MODULE: ./src/scripts/utils/newsletter-handler.js
var handleNewsletterForms = function handleNewsletterForms(alreadyHasNewsletter) {
  var handleModalNewsletter = function handleModalNewsletter() {
    var newsletterModal = document.querySelector("newsletter-modal");
    var trigger = document.querySelector(".newsletter-trigger");
    if (!trigger || !newsletterModal) return;

    if (!alreadyHasNewsletter) {
      var handleTriggerClick = function handleTriggerClick() {
        newsletterModal.classList.toggle("is-open");
      };

      trigger.addEventListener("click", handleTriggerClick);
      trigger.innerHTML = "\n        <svg\n          width=\"32\"\n          height=\"32\"\n          viewBox=\"0 0 32 32\"\n          fill=\"none\"\n          xmlns=\"http://www.w3.org/2000/svg\">\n          <path\n            d=\"M8 10V22H24V10M8 10H24M8 10L16.2051 17.0345L24 10\"\n            stroke=\"#0C0C0C\"\n            stroke-width=\"1.5\"></path>\n          <rect\n            x=\"17\"\n            width=\"15\"\n            height=\"15\"\n            rx=\"7.5\"\n            fill=\"#B14B1E\"></rect>\n          <path d=\"M23.936 11.5V4.405H22.363V3.305H25.223V11.5H23.936Z\" fill=\"white\"></path>\n        </svg>\n      ";
      var form = newsletterModal.querySelector("form");
      if (!form) return;
      var observer = new MutationObserver(function (mutations) {
        var formText = form.textContent.toLowerCase();

        if (formText.includes("bedankt voor je inschrijving") || formText.includes("thank you for signing up") || formText.includes("merci de vous être inscrit") || formText.includes("bedankt voor het aanmelden")) {
          localStorage.setItem("hasNewsletter", true);
          trigger.removeEventListener("click", handleTriggerClick);
          trigger.innerHTML = "\n            <svg\n              width=\"32\"\n              height=\"32\"\n              viewBox=\"0 0 32 32\"\n              fill=\"none\"\n              xmlns=\"http://www.w3.org/2000/svg\">\n              <path\n                d=\"M8 10V22H24V10M8 10H24M8 10L16.2051 17.0345L24 10\"\n                stroke=\"#0C0C0C\"\n                stroke-width=\"1.5\"></path>\n            </svg>\n          ";
          setTimeout(function () {
            newsletterModal.classList.remove("is-open");
          }, 2000);
          observer.disconnect();
        }
      });
      observer.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };

  var handleSectionNewsletter = function handleSectionNewsletter() {
    var newsletterForms = document.querySelectorAll(".newsletter form");
    newsletterForms.forEach(function (form) {
      var observer = new MutationObserver(function (mutations) {
        var formText = form.textContent.toLowerCase();

        if (formText.includes("bedankt voor je inschrijving") || formText.includes("thank you for signing up") || formText.includes("merci de vous être inscrit") || formText.includes("bedankt voor het aanmelden")) {
          localStorage.setItem("hasNewsletter", true);
          observer.disconnect();
        }
      });
      observer.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };

  handleModalNewsletter();
  handleSectionNewsletter();
};

/* harmony default export */ var newsletter_handler = (handleNewsletterForms);
;// CONCATENATED MODULE: ./src/scripts/extenders/header.js








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var HeaderComponent = /*#__PURE__*/function (_HTMLElement) {
  (0,inherits/* default */.Z)(HeaderComponent, _HTMLElement);

  var _super = _createSuper(HeaderComponent);

  function HeaderComponent() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, HeaderComponent);

    _this = _super.call(this);

    var init = function init() {
      handleAnnouncementBarScroll();
      handleAnnouncementBarEventListeners();
      handleMobileToggle();
      handleNavigationButtonClick();
      handleMegaMenu();
      handleWishlistCounter();
      handleNewsletterModal();
    };

    var handleWishlistCounter = function handleWishlistCounter() {
      var _JSON$parse;

      var counter = document.querySelector(".js-counter");
      var amount = (_JSON$parse = JSON.parse(localStorage.getItem("Suite702_wishlist"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.length;

      if (amount > 0) {
        counter.classList.add("js-counter--active");
        counter.innerHTML = amount;
      } else {
        counter.classList.remove("js-counter--active");
        counter.innerHTML = "";
      }
    };
    /**
     * Hide announcement bar.
     *
     * @param headerElement
     * @type {HTMLElement}
     */


    var hideAnnouncementBar = function hideAnnouncementBar(headerElement) {
      var announcementBarElement = document.querySelector(".announcement-bar");
      var mobileNavigation = document.querySelector(".mobile-navigation");
      var buttonRow = document.querySelector(".button-row");
      var configuratorMedia = document.querySelector(".configurator-media");
      var predictiveSearch = document.querySelector(".predictive-search-modal");
      var megaMenus = document.querySelectorAll(".mega-menu");

      if (headerElement && announcementBarElement) {
        announcementBarElement.style.zIndex = "1000";
        announcementBarElement.classList.add("header--has-scrolled");
        headerElement.classList.add("header--has-scrolled");
        headerElement.style.transform = "translateY(0px)";
        predictiveSearch.style.transform = "translateY(0px)";
        mobileNavigation.style.transform = "translateY(0px)";
        megaMenus.forEach(function (megaMenu) {
          megaMenu.style.top = "62px";
        });
      }

      // if (buttonRow && configuratorMedia) {
      //   buttonRow.style.top = "368px";
      //   configuratorMedia.style.top = "78px";
      // }
    };
    /**
     * Set hide announcement bar state in a session storage.
     *
     * @param state
     * @type {Boolean}
     */


    var setHideAnnouncementBarSession = function setHideAnnouncementBarSession(state) {
      sessionStorage.setItem("showAnnouncementBar", state);
    };
    /**
     * Get state from session of the announcement bar.
     */


    var getStateOfAnnouncementBarSession = function getStateOfAnnouncementBarSession() {
      return sessionStorage.getItem("showAnnouncementBar");
    };
    /**
     * Show announcement bar.
     *
     * @param headerElement
     */


    var showAnnouncementBar = function showAnnouncementBar(headerElement) {
      var announcementBarElement = document.querySelector(".announcement-bar");
      var announcementBarHeight = announcementBarElement.offsetHeight;
      var mobileNavigation = document.querySelector(".mobile-navigation");
      var sessionState = getStateOfAnnouncementBarSession();
      var buttonRow = document.querySelector(".button-row");
      var configuratorMedia = document.querySelector(".configurator-media");
      var predictiveSearch = document.querySelector(".predictive-search-modal");
      var megaMenus = document.querySelectorAll(".mega-menu");

      if (headerElement && announcementBarElement) {
        if (sessionState === "false") {
          announcementBarElement.classList.add("js-disabled");
        } else {
          headerElement.style.transform = "translateY(".concat(announcementBarHeight, "px)");
          predictiveSearch.style.transform = "translateY(".concat(announcementBarHeight, "px)");
          mobileNavigation.style.transform = "translateY(".concat(announcementBarHeight, "px)"); // Check if announcement bar should still be shown after transition

          setTimeout(function () {
            if (!headerElement.classList.contains("header--has-scrolled") && !announcementBarElement.classList.contains("js-disabled")) {
              announcementBarElement.style.zIndex = "1005";
            }
          }, 250);
          megaMenus.forEach(function (megaMenu) {
            megaMenu.style.top = "".concat(62 + announcementBarHeight, "px");
          });
        }

        announcementBarElement.classList.remove("header--has-scrolled");
        headerElement.classList.remove("header--has-scrolled");
      }

      // if (buttonRow && configuratorMedia) {
      //   buttonRow.style.top = "400px";
      //   configuratorMedia.style.top = "110px";
      // }
    };
    /**
     * Handle announcement bar scroll
     */


    var handleAnnouncementBarScroll = function handleAnnouncementBarScroll() {
      var headerElement = document.querySelector(".header");
      var sessionState = getStateOfAnnouncementBarSession();
      var announcementBarElement = document.querySelector(".announcement-bar");

      if (sessionState === "false") {
        announcementBarElement.classList.add("js-disabled");
      } else {
        showAnnouncementBar(headerElement);
      }

      if (headerElement) {
        var announcementBarHeight = announcementBarElement.offsetHeight;
        var offset = announcementBarHeight * 3;
        window.addEventListener("scroll", function () {
          var scrollPosition = window.scrollY;

          if (scrollPosition > offset) {
            hideAnnouncementBar(headerElement);
          } else {
            showAnnouncementBar(headerElement);
          }
        });
      }
    };
    /**
     * Handle announcement bar events.
     */


    var handleAnnouncementBarEventListeners = function handleAnnouncementBarEventListeners() {
      var headerElement = document.querySelector(".header");
      var announcementBarCloseButtonElement = document.querySelector("#js-close-announcement-bar");

      if (announcementBarCloseButtonElement && headerElement) {
        announcementBarCloseButtonElement.addEventListener("click", function () {
          setHideAnnouncementBarSession(false);
          hideAnnouncementBar(headerElement);
        });
      }
    };
    /**
     * Mobile menu toggle switcher
     *
     * @returns
     */


    var handleMobileToggle = function handleMobileToggle() {
      var toggle = document.querySelector("#js-trigger-mobile-menu");
      var mobileNav = document.querySelector(".mobile-navigation");
      var headerElement = document.querySelector(".header");
      var searchResultsHolder = document.querySelector(".search-results-holder");
      var searchModal = document.querySelector("search-modal");
      var form = searchModal === null || searchModal === void 0 ? void 0 : searchModal.querySelector(".form");
      var submit = searchModal === null || searchModal === void 0 ? void 0 : searchModal.querySelector(".form__submit");
      if (!toggle) return false;
      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        toggle.classList.toggle("is-open");

        if (headerElement.dataset.template == "index") {// headerElement.classList.toggle('js-active')
        }

        mobileNav.classList.toggle("js-mobile-navigation-open"); // Close search results if open

        if (searchResultsHolder) {
          searchResultsHolder.remove();
        }

        var suggestionsHolder = document.querySelector(".suggestions-holder");
        var suggestionBackground = document.querySelector(".js-suggestion-background");
        var backgroundCurtain = document.querySelector(".background-curtain");
        var popularResults = document.querySelector(".popular-results");
        var predictiveSearch = document.querySelector(".predictive-search-results--active"); // Close search suggestions if open

        suggestionsHolder === null || suggestionsHolder === void 0 ? void 0 : suggestionsHolder.classList.remove("suggestions-holder--active");
        suggestionBackground === null || suggestionBackground === void 0 ? void 0 : suggestionBackground.classList.remove("background-curtain--active");
        backgroundCurtain === null || backgroundCurtain === void 0 ? void 0 : backgroundCurtain.classList.remove("background-curtain--active");
        popularResults === null || popularResults === void 0 ? void 0 : popularResults.classList.remove("js-active"); // Also close predictive search

        if (predictiveSearch) {
          predictiveSearch.classList.add("search-hidden");
        } // Now check the status of the mobileMenu for body-scroll-lock


        if (mobileNav.classList.contains("js-mobile-navigation-open")) {
          // add body scroll lock.
          body_lock/* default.lock */.Z.lock();
          document.querySelector('#chat-button').style.display = 'none';
        } else {
          // remove body scroll lock.
          body_lock/* default.unlock */.Z.unlock();
          document.querySelector('#chat-button').style.display = 'block';
        }
      });
    };

    var handleNewsletterModal = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.addEventListener('DOMContentLoaded', function () {
                  var newsletterModal = document.querySelector("newsletter-modal");
                  var trigger = document.querySelector(".newsletter-trigger");
                  var closeTrigger = document.querySelector(".newsletter-close-trigger");
                  var alreadyHasNewsletter = localStorage.getItem("hasNewsletter");
                  if (!trigger || !newsletterModal) return;
                  newsletter_handler(alreadyHasNewsletter);
                  if (alreadyHasNewsletter) return;
                  closeTrigger === null || closeTrigger === void 0 ? void 0 : closeTrigger.addEventListener("click", function () {
                    newsletterModal.classList.remove("is-open");
                  });
                  newsletterModal.addEventListener("click", function (e) {
                    var modalInner = newsletterModal.querySelector(".newsletter-modal__inner");

                    if (!modalInner.contains(e.target)) {
                      newsletterModal.classList.remove("is-open");
                    }
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleNewsletterModal() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * Close mega menu.
     *
     * @param megaMenuElement
     */


    var closeMegaMenu = function closeMegaMenu(megaMenuElement) {
      if (megaMenuElement) {
        megaMenuElement.classList.remove("js-mega-menu-open");
        megaMenuElement.style.transform = "translateX(100%)";
      }
    };
    /**
     * Open mega menu.
     *
     * @param megaMenuElement
     */


    var openMegaMenu = function openMegaMenu(megaMenuElement) {
      if (megaMenuElement) {
        megaMenuElement.classList.add("js-mega-menu-open");
        megaMenuElement.style.transform = "translateX(0)";
      }
    };
    /**
     * Handle open mobile mega menu.
     *
     * @param megaMenuId
     */


    var handleOpenMobileMegaMenu = function handleOpenMobileMegaMenu(megaMenuId) {
      var megaMenuElement = document.getElementById(megaMenuId);

      if (megaMenuElement.classList.contains("js-mega-menu-open")) {
        closeMegaMenu(megaMenuElement);
      } else {
        openMegaMenu(megaMenuElement);
      }
    };
    /**
     * Handle Navigation button click.
     */


    var handleNavigationButtonClick = function handleNavigationButtonClick() {
      var allNavigationMenuItem = document.querySelectorAll(".js-trigger-mega-menu");
      allNavigationMenuItem.forEach(function (navigationMenuItem) {
        var megaMenuId = navigationMenuItem.dataset.menuId;
        navigationMenuItem.addEventListener("click", function () {
          handleOpenMobileMegaMenu(megaMenuId);
        });
      });
    };
    /**
     * Removes active classes when menu is closing
     *
     * @returns
     */


    var handleActiveItems = function handleActiveItems() {
      var layer1items = document.querySelectorAll(".js-layer1");

      if (layer1items) {
        layer1items.forEach(function (item) {
          item.classList.remove("active");
        });
      }
    };
    /**
     * Enable the mega menu switching
     *
     * @returns
     */


    var handleMegaMenu = function handleMegaMenu() {
      var megaMenuButtons = document.querySelectorAll(".header__menu .nav__item.nav__item--mega-menu");
      var megaMenuContainer = document.querySelector(".mega-menu-container");
      var headerElement = document.querySelector(".header");
      if (megaMenuButtons.length === 0) return false; // Menu only for iPad and above

      var breakpointTablet = "1024px";
      if (!matchMedia("screen and (min-width: ".concat(breakpointTablet, ")")).matches) return false;
      /* Add one or more listeners to an element
       ** @param {DOMElement} element - DOM element to add listeners to
       ** @param {string} eventNames - space separated list of event names, e.g. 'click change'
       ** @param {Function} listener - function to attach for each event as a listener
       */

      function addListenerMulti(el, s, fn) {
        s.split(" ").forEach(function (e) {
          return el.addEventListener(e, fn, false);
        });
      } // Specific handlers


      var closeAllMegaMenu = function closeAllMegaMenu() {
        var megaMenuItems = megaMenuContainer.querySelectorAll(".mega-menu");
        var body = document.querySelector("body"); // megaMenuContainer.classList.remove('js-active')

        if (body.classList.contains("template-index")) {// headerElement.classList.remove('js-active')
        }

        megaMenuButtons.forEach(function (button) {
          return button.querySelector(".nav__button").classList.remove("nav__button--active");
        });
        if (megaMenuItems.length > 0) megaMenuItems.forEach(function (item) {
          // item.classList.remove('js-active')
          if (item.id !== "shop") {
            item.classList.remove("js-active");
          }
        });
        handleActiveItems();
      };

      var openMegaMenu = function openMegaMenu(target) {
        var megaMenu = document.querySelector(".mega-menu" + target);
        closeAllMegaMenu();
        megaMenuContainer.classList.add("js-active");
        headerElement.classList.add("js-active");
        megaMenu.classList.add("js-active"); // setTimeout(() => {
        //   megaMenu.classList.add('js-active')
        // }, 150)
      }; // Close events


      megaMenuContainer.addEventListener("mouseleave", function () {
        return closeAllMegaMenu();
      }); // Close megamenu's when clicked outside of it. Especially for iPad landscape.
      // document.addEventListener('click', (e) => {
      //   const header = document.querySelector('.header')
      //   const megaMenu = document.querySelector('.mega-menu-container')
      //   let target = e.target
      //   do {
      //     if (target == megaMenu || target == header) {
      //       // This is a click inside, does nothing, just return.
      //       return
      //     }
      //     // Go up the DOM
      //     target = target.parentNode
      //   } while (target)
      //   // This is a click outside.
      //   closeAllMegaMenu()
      // })

      megaMenuButtons.forEach(function (button) {
        addListenerMulti(button, "click mouseenter", function (event) {
          // event.preventDefault()
          var target = button.querySelector(".nav__button").dataset.target ? button.querySelector(".nav__button").dataset.target : null;
          if (target) openMegaMenu(target); // Button animations

          var buttonElement = button.querySelector(".nav__button");
          if (buttonElement) buttonElement.classList.add("nav__button--active");
        });
      });
    };

    init();
    return _this;
  }

  return HeaderComponent;
}( /*#__PURE__*/(0,wrapNativeSuper/* default */.Z)(HTMLElement));

customElements.define("header-component", HeaderComponent);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 8677;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			8677: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(3718); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;